import { defineStore } from 'pinia';
import { SET_ROTATIONAL_BANNER_DATA } from '../../../../store/StoreConstants/BannnersDataConstants';

export const useBannersDataStore = defineStore('bannersData', {
  state: () => ({
    rotationalBannersData: null,
  }),
  actions: {},
});
